export default {
  tabMenu: {
    audit: 'Rewizja',
    auditConfiguration: 'Specyfikacje audytu',
    quality: 'Jakość',
    qualityConfiguration: 'Predefiniowane ustawienia jakości',
    qualityStatistics: 'Statystyki jakości',
  },
};
